/**
 * @file: 返工活动
 * @author: wence
 */
import React, {Component} from 'react';
import PropType from 'prop-types';
import cn from 'classnames';

import './index.less';

class Modal extends Component {
    static propTypes = {
        visible: PropType.bool,
        onCancel: PropType.func
    }
    top = 0;
    componentDidMount() {
        document.body.style.width = '100%';
        const navBar = document.querySelector('.nav-bar');

        this.top = window.scrollY;
        document.body.style.top = -this.top + 'px';
        document.body.style.position = 'fixed';
        navBar.style.top = 0;
    }

    componentWillUnmount() {
        document.body.style.width = '';
        const navBar = document.querySelector('.nav-bar');

        navBar.style.top = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.scrollTop = document.documentElement.scrollTop = this.top;
    }

    render() {
        const {visible, onCancel} = this.props;
        return (
            <div className={cn('spu-resume-modal', {on: visible})}>
                <div className="mask"></div>
                <div className="body">
                    <div className="title">
                        活动规则
                    </div>
                    <div className="content">
                        <div className="content-inner">
                            <div className="content-inner-text">
                                活动时间：2020年5月29日 - 6月18日；<br />
                                秒杀时间：2020年5月29日起，限时秒杀抢占优惠资格，抢完为止；<br />
                                活动适用人群：百度安全新老用户皆可参与，提交表单成功后，
                                将有客服24小时之内与您联系，或在线咨询/致电咨询400-805-4999，
                                抢占秒杀价格并完成后续购买流程；参与活动的用户应同时遵守百度安全官网所示的《用户服务协议》、
                                产品相关的协议及页面使用规则（包括但不限于产品服务等级协议，使用规范，产品服务条款等）；<br />
                                对于通过恶意注册或其他不正当手段在本次活动中进行非法牟利、炒作、转售、获奖、虚假交易的用户，
                                百度安全有权取消其资格或其因参加活动所获权益，有权采取包括不限于停止服务、封停帐号、冻结代金券等止损和保护措施；
                                如该违规行为给百度安全造成损失的，百度安全保留追究其民事责任和刑事责任的权利；<br />
                                百度安全在法律允许的范围内享有对本活动的解释权。
                            </div>
                        </div>
                    </div>
                    <div className="footer">
                        <div className="spu-activity-btn" onClick={onCancel}>确认</div>
                    </div>
                </div>
            </div>
        );
    }
}
export default class ActivityResume extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: false
        };

        if (this.isPC()) {
            window.location.href = '/activity/resume';
        }
    }

    getUnicodeName = name => {
        return encodeURIComponent(name);
    }

    render() {
        return (
            <div className="spu-activity-resume">
                <div className="banner">
                </div>
                <div className="spike-title">
                    即刻提交表单抢占限时秒杀资格
                </div>
                <div className="spike-card icon1">
                    <div className="spike-card-title">软硬件一体多人快速测温系统（中通量版）</div>
                    <div className="spike-card-point icon1">硬件设备：多人体温检测智能终端GTT</div>
                    <div className="spike-card-des">
                        200万高精度人脸+体温检测双目摄像机<br />
                        国产测温传感器芯片<br />
                        测温范围：0℃~50℃<br />
                        测温精确度±0.5度<br />
                    </div>
                    <div className="spike-card-point icon2">软件平台：物可视IOTVIZ</div>
                    <div className="spike-card-des">
                        实现设备接入、管理、远程控制<br />
                        所有数据及图像均有迹可循<br />
                        支持数据统计分析、图像查看下载等<br />
                        推荐学校，办公区场景使用<br />
                    </div>
                    <div className="spick-card-price">
                        <div className="price">35000</div>
                        <div className="unit">元/套</div>
                        <div>省35000元</div>
                    </div>

                    <a
                        href={`/m/apply?name=${this.getUnicodeName('#百度AI体温检测秒杀活动# 软硬件一体多人快速测温系统（中通量版）')}`}
                        className="spu-activity-btn">限量秒杀</a>
                    <div className="spu-card-mobile">电话抢购：400-805-4999</div>
                </div>

                <div className="spike-card icon2" style={{marginTop: '.4rem'}}>
                    <div className="spike-card-title">单人门禁智能测温系统（低通量版）</div>
                    <div className="spike-card-des">
                        体温检测+人脸识别智能功能双集成<br />
                        内置高精度热红外模块<br />
                        测温范围：35℃~42℃<br />
                        最优测温距离0.5米<br />
                        测温精确度±0.5℃<br />
                        主码流：1920*1080<br />
                        尺寸：215x125x25mm<br />
                    </div>
                    <div className="spike-card-des">
                        支持低温报警、高温报警及区域温差报警等多种报警方式<br />
                        支持接口数据上报<br />
                        可广泛应用于通道、门口、闸机等管控出入口或测温区域<br />
                    </div>
                    <div className="spick-card-price">
                        <div className="price">5200</div>
                        <div className="unit">元/套</div>
                        <div>省12200元</div>
                    </div>

                    <a
                        href={`/m/apply?name=${this.getUnicodeName('#百度AI体温检测秒杀活动# 单人门禁智能测温系统（低通量版）')}`}
                        className="spu-activity-btn">限量秒杀</a>
                    <div className="spu-card-mobile">电话抢购：400-805-4999</div>
                </div>

                <div className="spike-card-detail">
                    <div className="spike-card-detail-title">活动规则</div>
                    <div className="spike-card-detail-content">
                        活动时间：2020年5月29日 - 6月18日；<br />
                        秒杀方式：2020年5月29日起，限时秒杀抢占优惠资格，抢完为止。
                        <span
                            className="spu-link"
                            onClick={() => this.setState({visible: true})}>查看详情</span>
                    </div>
                </div>

                <div className="spu-activity-title">核心优势</div>

                <div className="spu-advantage">
                    {
                        [
                            {
                                title: '实时高效',
                                des: <div>
                                    <p>在单人通道顺序通行条件下，可在1分钟内实现对逾200人同时通过的体温实时检测，实现人群无停留过检，缓解人员堵塞。</p>
                                    <p>*参考数据，受人群密度及行进速度影响。</p>
                                </div>
                            },
                            {
                                title: '精准可靠',
                                des: '实现了体温检测与人脸识别的技术同步及佩戴口罩时的识别问题，可准确定位、快速锁定体温异常人员并实时自动告警，方便工作人员进行二次复检。'
                            },
                            {
                                title: '非接触无感知',
                                des: '借助全自动化的体温检测，被检人员仅需做弱配合，大幅减少相互的近距离接触，降低潜在的安全隐患。'
                            },
                            {
                                title: '快速部署降低成本',
                                des: '实现检测结果的实时可视化，并可在通道、重要区域快速部署，有效降低成本，缓解疫情防控期间紧张的人力资源调配。'
                            }
                        ].map((item, index) => {
                            return (
                                <div
                                    className={`spu-advantage-item bg${index + 1}`}
                                    key={index}>
                                    <div className="title">{item.title}</div>
                                    <div className="des">{item.des}</div>
                                </div>
                            );
                        })
                    }
                </div>

                <div className="spu-activity-title">合作伙伴</div>
                <div className="spu-activity-list">
                    北京清河火车站<br />
                    北京五道口地铁<br />
                    北京大学附属小学<br />
                    中关村一小<br />
                    中关村二小<br />
                    八里庄小学<br />
                    北航大学校区<br />
                    北京数字大厦<br />
                    北京长安商场<br />
                    北京华联商超10余家<br />
                    北京八宝山公墓等20处墓园<br />
                    郑州三附医院<br />
                    华润物业<br />
                    金隅文化<br />
                    紫金物业<br />
                </div>

                <div className="spu-footer-container">
                    <div className="spu-footer">
                        即刻提交表单抢占限时秒杀资格
                        <a
                            href={`/m/apply?name=${this.getUnicodeName('#百度AI体温检测秒杀活动#')}`}
                            className="spu-btn">立即秒杀</a>
                    </div>
                </div>

                {this.state.visible && <Modal
                    key={this.state.key}
                    visible={this.state.visible}
                    onCancel={() => this.setState({visible: false})} />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/activityResume/index.js